import React, { useState } from "react";
import { useQuery } from "react-query";
import { getPlatformRate } from "../../../api/rate";
import Loading from "../../shared/Loading";
import { AiOutlinePlusSquare } from "react-icons/ai";
import AddPlatformRate from "../../modals/AddPlatformRate";

const boxShadowStyle = {
  boxShadow: "0px 2px 9px 0px #00000008",
  userSelect: "none",
};

const PlatformRate = () => {
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useQuery("platform-rate", getPlatformRate);

  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="bg-white w-full rounded-lg p-4 space-y-2 font-Neurial">
            <div className="flex justify-between items-center">
              <div className="text-[#7B7B7B] text-[16px]">
                Set and adjust Platform rate
              </div>
              <div className="flex items-center gap-3">
                <div
                  className="border-[1px] border-[#E9EFF4] bg-white rounded-lg p-2 cursor-pointer"
                  title={`Search`}
                  style={boxShadowStyle}
                ></div>
                <div
                  className="bg-[#2121F11A] p-2 rounded-[5px] cursor-pointer"
                  title="Add new rate"
                  onClick={() => setOpen(true)}
                >
                  <div className="text-[#2121F1] font-bold text-[15px] font-Neurial flex items-center gap-1">
                    <AiOutlinePlusSquare />
                    <span>Add/Update Rate</span>
                  </div>
                </div>
              </div>
            </div>

            {data &&<>
            <h5>{data?.baseCurrency} / {data?.quoteCurrency}</h5>
            <p className="font-bold text-xl">{Number(data?.rate || 0).toLocaleString()}</p>
            </>}
          </div>
        </>
      )}

      <AddPlatformRate open={open} setOpen={setOpen} data={data} />
    </div>
  );
};

export default PlatformRate;
